const KEY = 'access-roles-v1';
// lightweight audit integration (no hard dependency for runtime)
let audit; try{ audit = require('../bread/auditLogService'); }catch{ audit = null; }

const seed = {
  permissions: [
    { key: 'view_dashboard', label: 'View Dashboard', group: 'System Access' },
    { key: 'manage_users', label: 'Manage Users', group: 'User Management' },
    { key: 'edit_policies', label: 'Edit Policies', group: 'Data Management' },
    { key: 'view_reports', label: 'View Reports', group: 'Data Management' },
    { key: 'run_scans', label: 'Run Trust Scans', group: 'System Access' },
    { key: 'configure_stack', label: 'Configure Stack Integrations', group: 'System Access' },
  ],
  roles: [
    { id: 'role-admin', name: 'Administrator', description: 'Full system access', users: 5, lastModified: '2024-01-15', perms: ['view_dashboard','manage_users','edit_policies','view_reports','run_scans','configure_stack'] },
    { id: 'role-manager', name: 'Manager', description: 'Department level access', users: 12, lastModified: '2024-01-10', perms: ['view_dashboard','view_reports','run_scans'] },
  ]
};

function load(){
  try{ const raw = localStorage.getItem(KEY); return raw ? JSON.parse(raw) : seed; }catch{ return seed; }
}

let state = load();
const subs = new Set();

function save(){ try{ localStorage.setItem(KEY, JSON.stringify(state)); }catch{} }
function publish(){ save(); subs.forEach(cb=>{ try{ cb(state); }catch{} }); }

export function subscribe(cb){ subs.add(cb); cb(state); return ()=> subs.delete(cb); }
export function getState(){ return state; }

export function upsertRole(role){
  const idx = state.roles.findIndex(r=> r.id === role.id);
  const payload = { ...role };
  payload.lastModified = new Date().toISOString().slice(0,10);
  if(!payload.id) payload.id = `role-${Math.random().toString(36).slice(2,7)}`;
  if(idx>=0) state.roles[idx] = { ...state.roles[idx], ...payload };
  else state.roles.unshift(payload);
  publish();
  try{ audit && audit.add && audit.add({ user: 'system', action: idx>=0?'role.update':'role.create', target: payload.id, status: 'success', ip: '-' }); }catch{}
}

export function removeRole(id){ state.roles = state.roles.filter(r=> r.id !== id); publish(); try{ audit && audit.add && audit.add({ user: 'system', action:'role.delete', target:id, status:'success', ip:'-' }); }catch{} }
export function setRolePerm(id, permKey, enabled){
  const r = state.roles.find(r=> r.id === id); if(!r) return;
  const set = new Set(r.perms||[]);
  if(enabled) set.add(permKey); else set.delete(permKey);
  r.perms = Array.from(set);
  r.lastModified = new Date().toISOString().slice(0,10);
  publish();
  try{ audit && audit.add && audit.add({ user:'system', action:'permission.toggle', target:`${id}:${permKey}`, status:'success', ip:'-' }); }catch{}
}

export function exportJSON(){ return state; }
export function importJSON(obj){ if(!obj) return; state = obj; publish(); }
